/**
 * @file index.jsx
 * @brief Wraps the Tiptap editor used for rich-text listing descriptions.
 */
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import styles from "./rich-text-editor.module.css";

/**
 * Render the rich-text editor used in listing forms.
 * @param {string} value Current HTML value shown in the editor.
 * @param {Function} onChange Callback invoked when the editor content changes.
 * @returns {JSX.Element|null} The editor UI, or null until the editor instance is ready.
 */
export default function RichTextEditor({ value, onChange }) {

    const editor = useEditor({
        extensions: [StarterKit],
        content: value || "",
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },
    });

    if (!editor) return null;

    return (
        <div className={styles.editorWrapper}>

            {/* Toolbar */}
            <div className={styles.toolbar}>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    className={editor.isActive("bold") ? styles.active : ""}
                >
                    B
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    className={editor.isActive("italic") ? styles.active : ""}
                >
                    I
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                >
                    H2
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleBulletList().run()}
                >
                    • List
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleOrderedList().run()}
                >
                    1. List
                </button>

            </div>

            <EditorContent editor={editor} className={styles.editor} />

        </div>
    );
}